import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import PageWrapper from 'components/ui/PageWrapper';
import Welcome from './Welcome';

const HomePage = (props) => {
  const { permissions } = props;
  const history = useHistory();
  useEffect(() => {
    if (
      permissions.includes('IsAdmin') ||
      permissions.includes('CanAccessCustomerInfo')
    ) {
      history.push('/Customers');
    }
  }, [history, permissions]);

  return (
    <PageWrapper>
      <Welcome />
    </PageWrapper>
  );
};

HomePage.propTypes = {
  permissions: PropTypes.array,
};

HomePage.defaultProps = {
  permissions: [],
};

export default HomePage;
